<template>
  <FormDocument type="Facture" api-type="invoices" :edit_doc_number="doc_number" />
</template>

<script>
import FormDocument from '@/components/Form/Document'

export default {
  props: {
    doc_number: [String, Number],
  },
  components: {
    FormDocument,
  },
  theme() {
    return {
      title: 'Modifier facture',
      subtitle: '',
    }
  },
}
</script>

<style></style>
